import { useEffect, useRef, useCallback } from 'react';

const IDLE_EVENTS = [
  'mousemove',
  'keydown',
  'mousedown',
  'touchstart',
  'scroll',
  'click',
];

const useIdleTimeout = (onIdle, timeoutMs, enabled = true) => {

  const timeoutRef = useRef(null);
  const onIdleRef  = useRef(onIdle);

  useEffect(() => { onIdleRef.current = onIdle; }, [onIdle]);

  const resetTimer = useCallback(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => onIdleRef.current(), timeoutMs);
  }, [timeoutMs]);

  useEffect(() => {

    if (!enabled) {
      clearTimeout(timeoutRef.current);
      return;
    }

    IDLE_EVENTS.forEach(ev =>
      window.addEventListener(ev, resetTimer, { passive: true })
    );

    resetTimer();

    return () => {
      IDLE_EVENTS.forEach(ev =>
        window.removeEventListener(ev, resetTimer)
      );
      clearTimeout(timeoutRef.current);
    };

  }, [enabled, resetTimer]);

};

export default useIdleTimeout;
